import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  value: string;
  onChange: (url: string) => void;
  defaultArticles?: string[];
}

export const SourceTextForGenerating: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <>
      <label className="block text-gray-700">{t('ads.content_for_generation')}</label>
      <textarea
        rows={10}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="mt-2 w-full p-2 border rounded-md"
        placeholder={t('ads.content_for_generation_placeholder')}
      />
    </>
  );
};
